import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
} from '@material-ui/core'
import { TailSpin } from 'react-loader-spinner'

// Popup de progression d'upload (photos / documents) — repris de la branche STAR
export function UploadProgressDialog({ open, progress, current, total }) {
  return (
    <Dialog
      open={open}
      onClose={() => {}} // fermeture désactivée pendant l'upload
      aria-labelledby='upload-dialog-title'
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <DialogContent>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
            padding: '40px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          }}
        >
          <div style={{ marginBottom: '20px' }}>
            <TailSpin
              height='50'
              width='50'
              color='#BBC808'
              ariaLabel='tail-spin-loading'
              radius='1'
              visible={true}
            />
          </div>

          <Typography
            variant='body1'
            style={{
              marginBottom: '8px',
              fontFamily: 'Poppins',
              fontWeight: 500,
              color: '#002226',
            }}
          >
            Téléchargement en cours...
          </Typography>

          <Typography
            variant='body2'
            style={{
              marginBottom: '16px',
              fontFamily: 'Poppins',
              color: '#002226B2',
            }}
          >
            {current > 0
              ? `Fichier ${current} sur ${total}`
              : total > 0
              ? `Préparation de ${total} fichier(s)...`
              : 'Démarrage...'}
          </Typography>

          <div
            style={{
              width: '200px',
              height: '8px',
              backgroundColor: '#e0e0e0',
              borderRadius: '4px',
              overflow: 'hidden',
              marginBottom: '8px',
            }}
          >
            <div
              style={{
                width: `${progress}%`,
                height: '100%',
                backgroundColor: '#BBC808',
                transition: 'width 0.3s ease',
              }}
            />
          </div>

          <Typography
            variant='caption'
            style={{
              fontFamily: 'Poppins',
              color: '#002226B2',
              fontWeight: 600,
            }}
          >
            {Math.round(progress)}% complété
          </Typography>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export function UploadErrorDialog({ open, message, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby='error-dialog-title'>
      <DialogTitle id='error-dialog-title'>Erreur de téléchargement</DialogTitle>
      <DialogContent>
        <Typography color='error'>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <button
          onClick={onClose}
          style={{
            fontFamily: 'Poppins',
            fontSize: '12px',
            fontWeight: 600,
            color: 'rgba(60, 101, 86, 1)',
            background: 'rgba(240, 243, 199, 1)',
            border: 0,
            borderRadius: '6px',
            padding: '8px 16px',
            cursor: 'pointer',
          }}
        >
          Fermer
        </button>
      </DialogActions>
    </Dialog>
  )
}
